import { action, observable, makeObservable, computed } from 'mobx';
import { Notify } from '$src/utils/notify';
import { controlCenterApi } from '$src/api/control-center-api';
import {
  eligibleOutdoorDevicesFilter,
  eligibleIndoorDevicesFilter,
  notEligibleDevicesFilter,
} from '$src/utils/devices/selectDevices';

export default class DevicesStore {
  devicesInLocation = [];

  setDevices = (devices) => {
    this.devicesInLocation = devices;
  };

  fetchDevices = async (locationId, userId) => {
    try {
      const devices = await controlCenterApi.fetchAllDevices(Number(userId), locationId);
      this.setDevices(devices);
    } catch (e) {
      this.setDevices([]);
      Notify.error('There was an error getting devices', e);
    }
  };

  subscribeDevice = async (device, userId, locationId) => {
    const { value, ...data } = device;
    await controlCenterApi.subscribeDevice(data, Number(userId), locationId);
  };

  unsubscribeDevice = async (userId, doorbotId, locationId) => {
    await controlCenterApi.unsubscribeDevice(userId, doorbotId, locationId);
  };

  get notEligibleDevices() {
    return notEligibleDevicesFilter(this.devicesInLocation);
  }

  get eligibleIndoorDevices() {
    return eligibleIndoorDevicesFilter(this.devicesInLocation);
  }

  get eligibleOutdoorDevices() {
    return eligibleOutdoorDevicesFilter(this.devicesInLocation);
  }

  get subscribedDevices() {
    return this.devicesInLocation.filter((e) => e.starkEnrolled);
  }

  bulkUpdate = async (devices, userId, locationId) => {
    const devicesToSubscribe = devices.filter((e) => e.starkEnrolled);
    const devicesToUnSubscribe = devices.filter((e) => !e.starkEnrolled);
    await Promise.all(devicesToSubscribe.map((e) => this.subscribeDevice(e, userId, locationId)));
    await Promise.all(devicesToUnSubscribe.map((e) => this.unsubscribeDevice(userId, e.doorbotId, locationId)));
  };

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      devicesInLocation: observable,
      setDevices: action,
      notEligibleDevices: computed,
      eligibleIndoorDevices: computed,
      eligibleOutdoorDevices: computed,
      subscribedDevices: computed,
    });
  }
}
